export const tour = new Shepherd.Tour({
    defaultStepOptions: {
        cancelIcon: {
            enabled: true
        },
        classes: 'class-1 class-2',
        scrollTo: true
    }, 
    useModalOverlay: true
});
const step1Text=`<p> Welcome to Wavenet Nimbus. To get familiar with the website you can take a tour by clicking the <b>next</b> button below.</p>
               <p> if you choose to exit instead, you can return to it at any point by clicking on the <b>Take Tour</b> button in the header.</p>`;
const step2Text = `<p>Apps available to your school are found on the home page. To manage these apps, simply click on the relevant <b>configure</b> button.
                 <p>If your school subscribes to Nimbus Sync, you will already see a <b>Google Sync</b> and a <b>Microsoft Sync</b> app here.</p>`;
const step3Text =`<p>On the <b>Discover</b> page you can find other apps your school can choose to install.</p>`;
const step4Text = `<p>If you are new to services from Wavenet, or you do not currently <b>import data</b> to us from your MIS, this is where you will need to start.</p>`;
const step5Text=`<p>Once you've imported your school’s data, or if this is already set up, please visit the <b>Users</b> and <b>Classes</b> pages to view what’s being imported.</p>`;
const step6Text=`<p>If you need to view or add additional administrators, please visit the <b>Permissions</b> page under the <b>Settings</b> menu.`;
const step7Text=`<p>If you need to view our user guide, speak to us, raise a support case and much more, please visit the <b>Help</b> section.</p>`;
const step8Text=`<p>…and that’s the end of the quick tour of the Wavenet Nimbus website.</p>
                 <p>If you have any questions at any point, please do not hesitate to get in contact with us.</p>`;
let steps = [{
    id: 'Step 1', title: "Welcome", text: step1Text,   
    buttons: [
        {
            action() {
                return this.cancel();
            },
            classes: 'shepherd-button-secondary',
            text: 'Exit'
        },
        {
            action() {
                return this.next();
            },            
            text: 'Next'
        }
    ]
}, {
    id: 'Step 2', title: "Apps", text: step2Text,
    when: {
        show: function() {
            jQuery('[data-shepherd-step-id="Step 2"]').addClass("mt-5");
        }
      },
    attachTo: {
        element: '.apps-container',
        on: 'bottom'
      },
    buttons: [
        {
            action() {
                return this.back();
            },
            classes: 'shepherd-button-secondary',
            text: 'Back'
        },
        {
            action() {
                return this.next();
            },
            text: 'Next'
        }
    ]
}, {
    id: 'Step 3', title: "Discover", text: step3Text,    
    attachTo: {
        element: '.menu_discover',
        on: 'left'
      }, buttons: [
        {
            action() {
                return this.back();
            },
            classes: 'shepherd-button-secondary',
            text: 'Back'
        },
        {
            action() {
                return this.next();
            },
            text: 'Next'
        }
    ]
}, {
    id: 'Step 4', title: "Import data", text: step4Text,   
    attachTo: {
        element: '.menu_import',
        on: 'left'
      }, buttons: [
        {
            action() {
                return this.back();
            },
            classes: 'shepherd-button-secondary',
            text: 'Back'
        },
        {
            action() {
                return this.next();
            },
            text: 'Next'
        }
    ]
}, {
    id: 'Step 5', title: "Users and Classes", text: step5Text,
    attachTo: {
        element: '.menu_users',
        on: 'left'
      },
    buttons: [
        {
            action() {
                return this.back();
            },
            classes: 'shepherd-button-secondary',
            text: 'Back'
        },
        {
            action() {
                return this.next();
            },
            text: 'Next'
        }
    ]
}
, {
    id: 'Step 6', title: "Settings", text: step6Text,
    attachTo: {
        element: '.menu_settings',
        on: 'left'
      },
    buttons: [
        {
            action() {
                return this.back();
            },
            classes: 'shepherd-button-secondary',
            text: 'Back'
        },
        {
            action() {
                return this.next();
            },
            text: 'Next'
        }
    ]
},{
    id: 'Step 7', title: "Help", text: step7Text,
    when: {
        show: function() {
            jQuery('[data-shepherd-step-id="Step 7"]').addClass("mt-5");
        }
      },
    attachTo: {
        element: '.menu_help',
        on: 'top'
      },
    buttons: [
        {
            action() {
                return this.back();
            },
            classes: 'shepherd-button-secondary',
            text: 'Back'
        },
        {
            action() {
                return this.next();
            },
            text: 'Next'
        }
    ]
},
 {
    id: 'Step 8', title: "Thank you", text: step8Text, buttons: [
        {
            action() {
                return this.back();
            },
            classes: 'shepherd-button-secondary',
            text: 'Back'
        },
        {
            action() {
                return this.cancel();
            },
            text: 'Finish'
        }
    ]
}]
tour.addSteps(steps);
